import { Modal, Spin, Table, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import useApi from "../../utils/useApi";

const { Text } = Typography;

function formatDateTime(value) {
  if (!value) return null;
  return new Date(value).toLocaleString("pt-BR");
}

export default function CameraEnablementHistoryModal({ camera, onClose }) {
  const { getCameraEnablementHistory } = useApi();

  const { data, isLoading } = useQuery({
    queryKey: ["camera-enablement-history", camera.key],
    queryFn: () => getCameraEnablementHistory(camera.key).then((r) => r.data),
    staleTime: 60_000,
  });

  const periods = data ?? [];

  const columns = [
    {
      title: "Ativada em",
      dataIndex: "start_datetime",
      key: "start_datetime",
      render: (value) => formatDateTime(value),
    },
    {
      title: "Desativada em",
      dataIndex: "end_datetime",
      key: "end_datetime",
      render: (value) => (value ? formatDateTime(value) : "Ativa no momento"),
    },
  ];

  return (
    <Modal
      open
      title={`Histórico de ativação — ${camera.name}`}
      onCancel={onClose}
      footer={null}
      width={600}>
      {isLoading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin />
        </div>
      ) : periods.length === 0 ? (
        <Text type="secondary">Sem histórico registrado ainda.</Text>
      ) : (
        <Table
          columns={columns}
          dataSource={periods}
          rowKey="id"
          pagination={{ pageSize: 10 }}
        />
      )}
    </Modal>
  );
}
